/* -----------------Globals--------------- */
import { useAppTheme } from "@hooks/useAppTheme";

/* -----------------Third parties--------------- */
import { Chip } from "react-native-paper";

type Props = {
	label: string;
	expired?: boolean;
};
const ProductStatusChip = (props: Props) => {
	const { expired, label } = props;
	const theme = useAppTheme();
	return (
		<Chip
			compact
			textStyle={{
				color: theme.colors.white,
				fontSize: 12,
			}}
			style={[
				{
					backgroundColor: expired
						? theme.palette.error.main
						: theme.colors.success.main,
				},
			]}
		>
			{label}
		</Chip>
	);
};

export default ProductStatusChip;
